import type { FormControlProps } from '@chakra-ui/react'
import { FormControl, FormLabel, Radio } from '@chakra-ui/react'
import type { PersonDto } from 'BrokerTsLib/src/dtos'
import { Selection, SelectionType } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { useSelections } from '../../../hooks'
import { useNameof } from '../../../hooks/useNameof'
import { RadioGroup } from '../RadioGroup'

function PersonType({ personPrefix, disabled, ...rest }: { personPrefix: string, disabled?: boolean } & FormControlProps) {
  const pnameof = useNameof<PersonDto>(personPrefix)

  const { setValue, watch, getFieldState } = useFormContext()

  const { data: dataTypOsoby } = useSelections(SelectionType.TypOsoby)

  const pType = watch(pnameof(x => x.type))

  return (
    <FormControl isInvalid={!!getFieldState(pnameof(x => x.type))?.error} {...rest}>
      <FormLabel>Typ osoby</FormLabel>

      <RadioGroup
        name={pnameof(x => x.type)}
        isDisabled={disabled}
        value={pType?.toString()}
        onChange={(value) => {
          const val = parseInt(value)
          switch (val) {
            case Selection.Person:
              setValue(pnameof(x => x.companyName), null)
              setValue(pnameof(x => x.idendificationNumber), null)
              break

            case Selection.Company:
              setValue(pnameof(x => x.name), null)
              setValue(pnameof(x => x.surname), null)
              setValue(pnameof(x => x.birthNumber), null)
              setValue(pnameof(x => x.birthday), null)
              setValue(pnameof(x => x.isForeigner), false)
              setValue(pnameof(x => x.nationalityId), null)
              break
          }

          setValue(pnameof(x => x.type), val)
        }}
      >
        {dataTypOsoby?.data.map((item) => (
          <Radio value={item.id.toString()} key={item.id}>
            {item.description}
          </Radio>
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default PersonType